import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTarifario = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tarifario',
        name: 'Tarifario',
        component: ViewTarifario,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
